import React from 'react';
import { StyledDescriptionDetails } from '../elements';
export const Description = ({
  children,
  ...rest
}) => /*#__PURE__*/React.createElement(StyledDescriptionDetails, rest, children);